import { Box, FormControl, FormHelperText, Typography } from '@mui/material'
import { red } from '@mui/material/colors'
import { TimePicker } from '@mui/x-date-pickers/TimePicker' // Import TimePicker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Dayjs } from 'dayjs'
import React from 'react'
import { CustomLabel } from '../StyledTextField'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

interface TimePickerProps {
  helperText?: string
  labelPrimary?: string
  labelSecondary?: React.ReactElement
  isHelperShow?: boolean
  required?: boolean
  value: string | Dayjs | null
  onChange: (v: string | null) => void
  error: boolean
  readOnly?: boolean
  format?: string // No need for a default format since it's just a time picker
  fullWidth?: boolean
}

const CustomTimePicker: React.FC<TimePickerProps> = ({
  helperText,
  labelPrimary,
  labelSecondary,
  isHelperShow = true,
  required = false,
  value,
  error,
  onChange,
  readOnly = false,
  format = 'HH:mm', // Default format for time
  fullWidth = false,
  ...rest
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl sx={{ paddingBottom: '5px' }} fullWidth={fullWidth}>
        {(labelPrimary || labelSecondary) && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ paddingBottom: 0 }}
          >
            <Box sx={{ padding: 0 }} display="flex" alignItems="center">
              <CustomLabel text={labelPrimary ? labelPrimary : ''} />
              {required && (
                <Typography
                  component="span"
                  sx={{
                    paddingLeft: (theme) => theme.spacing(1 / 2),
                    paddingRight: (theme) => theme.spacing(1 / 2),
                    height: 16,
                    fontSize: 10,
                    marginLeft: '5px',
                    color: red[400],
                  }}
                >
                  *
                </Typography>
              )}
            </Box>
            {labelSecondary}
          </Box>
        )}
        <TimePicker
          readOnly={readOnly}
          value={value}
          slotProps={{
            textField: { error: error, fullWidth: true },
            mobilePaper: {
              sx: {
                '& .MuiTimePickerToolbar-separator': {
                  position: 'relative',
                  top: -3,
                },
              },
            },
          }}
          defaultValue={'HH:mm'}
          format={format}
          ampm={false}
          sx={{}}
          onChange={(newValue: any) => {
            onChange(newValue as any)
          }}
          {...rest}
        />

        {isHelperShow &&
          (helperText ? (
            <FormHelperText
              sx={{
                height: 12,
                m: 0,
              }}
              error={error}
            >
              {helperText}
            </FormHelperText>
          ) : (
            <Box sx={{ height: 12 }} />
          ))}
      </FormControl>
    </LocalizationProvider>
  )
}

export default CustomTimePicker
